var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.scssLocale},[_c('loading-page',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.loading),expression:"this.$store.state.loading"}]}),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('notification'),_c('warning-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }